import React from 'react'
import LogoHeader from '../LogoHeader/LogoHeader'
import { ModalProps } from './types'

const Modal = ({
  children,
  error = false,
  hideStationLogo = false,
}: ModalProps) => {
  return (
    <div className={`modal-style ${error ? 'active' : ''}`}>
      {!hideStationLogo && <LogoHeader />}
      <div className="content-style">{children}</div>
    </div>
  )
}
export default Modal
